import { operatorApiFetch } from './apiService';

const operatorAuthService = {
  // 登入
  login: async (workspace, username, password) => {
    const response = await operatorApiFetch('login', {
      method: 'POST',
      body: { workspace, username, password }
    });
    const data = await response.json();

    // JWT token is stored in HTTP-only cookie by the server
    return data;
  },

  // TOTP 驗證（登入第二步）
  verifyTotp: async (pendingToken, code) => {
    const response = await operatorApiFetch('verify_totp', {
      method: 'POST',
      body: { pending_token: pendingToken, code }
    });
    return response.json();
  },

  // 登出
  logout: async () => {
    const response = await operatorApiFetch('logout', {
      method: 'DELETE'
    });
    const data = await response.json();

    // HTTP-only cookie is cleared by the server
    return data;
  },

  // 取得當前操作員資訊
  getCurrentOperator: async () => {
    const res = await operatorApiFetch('current_operator', {
      method: 'GET'
    });
    return res.json();
  },

  // TOTP 管理 API
  totpSetup: async () => {
    const res = await operatorApiFetch('totp/setup', { method: 'POST' });
    return res.json();
  },

  totpEnable: async (code) => {
    const res = await operatorApiFetch('totp/enable', {
      method: 'POST',
      body: { code }
    });
    return res.json();
  },

  totpDisable: async (password) => {
    const res = await operatorApiFetch('totp/disable', {
      method: 'DELETE',
      body: { password }
    });
    return res.json();
  },

  totpStatus: async () => {
    const res = await operatorApiFetch('totp/status', { method: 'GET' });
    return res.json();
  },

  totpRegenerateBackupCodes: async (password) => {
    const res = await operatorApiFetch('totp/regenerate_backup_codes', {
      method: 'POST',
      body: { password }
    });
    return res.json();
  }
};

export default operatorAuthService;
